import { get, upload } from '../request';

export async function fetchLastDate(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/dataload/current`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function importData(
  { equityfinderService },
  authenticationToken,
  { data },
) {
  const url = `${equityfinderService}/equityfinder/dataload`;
  const { body } = await upload(authenticationToken, url, data);
  return body;
}

export async function fetchData({ equityfinderService }, authenticationToken) {
  const url = `${equityfinderService}/equityfinder/dataload`;
  const { body } = await get(authenticationToken, url);
  return body;
}
